# string -> string
intercap = (str) ->
  temp = str.replace /-+(.)/g, (match, firstLetter) ->
    firstLetter.toUpperCase()
  temp.substring(0, 1).toLowerCase() + temp.substring(1)

hyphenate = (str) ->
  str.replace /(.)([A-Z])/g, (match, previousLetter, capitalLetter) ->
    "#{previousLetter}-#{capitalLetter.toLowerCase()}"
  .toLowerCase()

paramName = (str) ->
  encodeURIComponent(str.replace(/-/g, "").toLowerCase())

paramValue = (value) ->
  if value instanceof Array
    ans = []
    for item in value
      ans.push(paramValue(item))
    ans.join(",")
  else if value instanceof Date
    pad = (num) ->
      if num < 10 then '0' + num else num
    [
      value.getUTCFullYear(),
      pad(value.getUTCMonth() + 1),
      pad(value.getUTCDate()),
      pad(value.getUTCHours()),
      pad(value.getUTCMinutes())
    ].join('-')
  else if typeof value == 'boolean'
    if value then 'yes' else 'no'
  else if typeof value == 'string'
    encodeURIComponent(value)
  else
    encodeURIComponent("#{value}")

extend = (base, objects...) ->
  for object in objects
    for key, value of object
      base[key] = value
  base

module.exports = {
  intercap
  hyphenate
  paramName
  paramValue
  extend
}
